//import { GoogleGenAI, GenerateContentResponse, Part } from "@google/genai";
//import { GEMINI_MODEL_VISION } from '../constants';

/*const API_KEY = process.env.API_KEY;

let ai: GoogleGenAI | null = null;

if (API_KEY) {
  ai = new GoogleGenAI({ apiKey: API_KEY });
} else {
  console.warn(
    "API_KEY environment variable not set. Gemini API calls will fail. Assicurati che la variabile d'ambiente API_KEY sia configurata."
  );
}*/
//let ai: null = null;

export const PutToService = (url:string, data:string, token?:string) => {
    return fetch(url,{
        method:'PUT',
        headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json',
            'Authorization': token ? `${token}` : ''
        },
        body:data
    })
}
export const DeleteToService = (url:string, token?:string) => {
    return fetch(url,{
        method:'DELETE',
        headers:{
            'Accept':'application/json',
            'Authorization': token ? `${token}` : ''
        },
    })
}

export const PostToService = (url:string, data:string, token?:string) => {
    return fetch(url,{
        method:'POST',
        headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json',
            'Authorization': token ? `${token}` : ''
        },
        body:data
    })
}

export const GetFromService = (url:string, token?:string) => {
    return fetch(url,{
        method:'Get',
        headers:{
            'Accept':'application/json',
            'Authorization': token ? `${token}` : ''
        },
    })
}



/*export const analyzeImageWithGemini = async (
  imageBase64DataUrl: string, // Full data URL: "data:image/jpeg;base64,..."
  promptText: string
): Promise<string> => {
  if (!ai) {
    throw new Error(
      "API Key per Gemini non configurata. Imposta la variabile d'ambiente API_KEY."
    );
  }

  if (!imageBase64DataUrl.startsWith('data:image')) {
    throw new Error("Formato immagine non valido. Atteso Data URL.");
  }

  const parts = imageBase64DataUrl.split(',');
  if (parts.length !== 2) {
    throw new Error("Data URL dell'immagine malformato.");
  }
  
  const mimeTypePart = parts[0].match(/:(.*?);/);
  if (!mimeTypePart || mimeTypePart.length < 2) {
    throw new Error("Impossibile estrarre il MIME type dall'immagine.");
  }
  const imageMimeType = mimeTypePart[1];
  const base64EncodedData = parts[1];

  try {
    const imagePart: Part = {
      inlineData: {
        mimeType: imageMimeType,
        data: base64EncodedData,
      },
    };

    const textPart: Part = {
      text: promptText,
    };

    const response: GenerateContentResponse = await ai.models.generateContent({
      model: GEMINI_MODEL_VISION,
      contents: { parts: [imagePart, textPart] },
      // config: {
      //   // You can add safetySettings, generationConfig etc. here if needed
      // }
    });
    
    return response.text;

  } catch (error) {
    console.error("Errore durante la chiamata all'API Gemini:", error);
    if (error instanceof Error) {
        // Check for specific Gemini API error structures if available, or just use message
        const geminiError = error as any; // eslint-disable-line @typescript-eslint/no-explicit-any
        if (geminiError.message) {
             throw new Error(`Errore API Gemini: ${geminiError.message}`);
        }
    }
    throw new Error("Errore sconosciuto durante l'analisi dell'immagine con Gemini.");
  }
};*/